/** @format */
import angular from 'angular';

export const scrollIntoViewOnPageChangeModule = 'sis-components.scroll.scrollIntoViewOnPageChange';

(function () {
    angular.module(scrollIntoViewOnPageChangeModule, []).directive('scrollIntoViewOnPageChange', () => ({
        restrict: 'A',
        scope: {
            scrollIntoViewOnPageChange: '@',
        },
        link: function (scope, element, attrs) {
            element.on('click', event => {
                const value = attrs.scrollIntoViewOnPageChange;
                if (!value) {
                    return;
                }
                const scrollTarget = document.querySelector(value);
                if (scrollTarget && (event.target.tagName === 'A' || event.target.tagName === 'SPAN')) {
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const scrollTargetRect = scrollTarget.getBoundingClientRect().top;
                    const scrollTargetPosition = scrollTargetRect - bodyRect;
                    window.scrollTo({
                        top: scrollTargetPosition,
                    });
                }
            });
        },
    }));
})();
